import { render, staticRenderFns } from "./KefuOrderEvaluation.vue?vue&type=template&id=27811493&scoped=true"
import script from "./KefuOrderEvaluation.vue?vue&type=script&lang=js"
export * from "./KefuOrderEvaluation.vue?vue&type=script&lang=js"
import style0 from "./KefuOrderEvaluation.vue?vue&type=style&index=0&id=27811493&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27811493",
  null
  
)

export default component.exports